import { CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic'

import AbbVieEAPImage from './AbbVieEAP.png'
import AccessHopeImage from './accessHopeLogo.png'
import AICoachIcon from './aiCoachIcon.svg'
import AmexBenefitsImage from './amexBenefits.png'
import AmWellImage from './amWellLogo.png'
import AmgenAnthemImage from './AnthemLogo.png'
import AycoLogo from './ayco_logo.png'
import ComPsychImage from './bahComPsych.png'
import CalmLogo from './calmLogo.png'
import CampBWellLogo from './CampBWellLogo.png'
import CaregiverWellnessImage from './caregiverWellness.png'
import CareOptionCareerWellbeing from './careOptionCareerWellbeing.png'
import CareOptionCoaching from './careOptionCoaching.png'
import CareOptionCouplesAndFamilyTherapy from './careOptionCouplesAndFamilyTherapy.png'
import CareOptionEmployerBenefits from './careOptionEmployerBenefits.png'
import CareOptionMedicationManagement from './careOptionMedicationManagement.png'
import CareOptionOutPatientSupport from './careOptionOutPatientSupport.png'
import CareOptionParentingSupport from './careOptionParentingSupport.png'
import CarrumHealthImage from './CarrumHealthLogo.png'
import ConfirmedImage from './confirmed.png'
import ConsumerMedicalImage from './consumerMedical.png'
import CredibleMindImage from './credibleMind.png'
import CumminsAnthemImage from './CumminsAnthemLogo.png'
import DawnBackground from './DawnBackground.png'
import DawnBackgroundMobile from './DawnBackgroundMobile.png'
import DawnBackgroundMobileWeb from './DawnBackgroundMobileWeb.png'
import DawnBackgroundWiderAspectRatio from './DawnBackgroundWiderAspectRatio.png'
import DaylightImage from './daylight.png'
import DellWellnessHubImage from './DellWellnessHub.png'
import FidelityLogo from './fidelityWellnessLogo.png'
import FIQImage from './FIQ.png'
import FitStudioImage from './FitStudio.png'
import ModeratBlack from './fonts/Moderat-Black.otf'
import ModeratBold from './fonts/Moderat-Bold.otf'
import ModeratMedium from './fonts/Moderat-Medium.otf'
import ModeratRegularItalic from './fonts/Moderat-Regular-Italic.otf'
import ModeratRegular from './fonts/Moderat-Regular.otf'
import FreshTriLogo from './FreshTri.png'
import HappifyLogo from './happifyLogo.png'
import HeadspaceLogo from './headspaceLogo.png'
import KaiserImage from './KP.png'
import LSCoImage from './LeviStraussCo.png'
import RibbonHeart from './lottie/ribbonAnimation.json'
import MayoClinicImage from './MayoClinicLogo.png'
import MedsConsultationPng from './MedsConsultationPng.png'
import MeQuilibriumLogo from './meQuilibriumLogo.png'
import MyAgileLifeLogo from './MyAgileLife.png'
import OptumImage from './optum.png'
import PAHPImage from './pahp.png'
import PowerOfWellnessImage from './PowerWellness.png'
import RallyImage from './RallyHealth.png'
import ReferralsImage from './referrals.png'
import ReThinkLogo from './ReThinkLogo.png'
import ScheduleImage from './schedule.png'
import SleepioImage from './sleepio.png'
import SpiritualHealthImage from './spiritualHealth.png'
import SupportivImage from './Supportiv.png'
import TeledocHealthImage from './TeledocHealthLogo.png'
import ThriveImage from './Thrive.png'
import TreatmentDetailTemplateHeaderDesktopImage from './treatmentDetailTemplateHeader_desktop.png'
import TreatmentDetailTemplateHeaderMobileImage from './treatmentDetailTemplateHeader_mobile.png'
import UHCImage from './UHC.png'
import VirginPulseLogo from './virginPulseLogo.png'
import WalmartSparkLogo from './WalmartSpark.png'
import WeightWatchersImage from './weightWatchers.png'
import WellBeingAtWalmartLogo from './WellBeingAtWalmart.png'
import ToolkitPromotionFamilyImage from './WellnessPromotionFamily.png'
import WellnessToolkitFooterImage from './WellnessToolkitFooter.png'
import WellnessToolkitHeaderImage from './WellnessToolkitHeader.png'
import WellnessToolkitHeaderLyraSelectImage from './WellnessToolkitHeaderLyraSelect.png'
import WellnessToolkitMobileHeaderImage from './WellnessToolkitMobileHeader.png'
import WellnessToolkitMobileHeaderLyraSelectImage from './WellnessToolkitMobileHeaderLyraSelect.png'
import WellnessToolkitMobileParentImage from './WellnessToolkitMobileParent.png'
import WellnessToolkitPurposeImage from './WellnessToolkitPurpose.png'
import WellnessToolkitRelationsImage from './WellnessToolkitRelations.png'
import WellnessToolkitWorkImage from './WellnessToolkitWork.png'
import WhilLogo from './WhilLogo.png'

// CDN imports for specific assets from your list

export const ModeratFonts = {
  'Moderat-Black': ModeratBlack,
  'Moderat-Bold': ModeratBold,
  'Moderat-Medium': ModeratMedium,
  'Moderat-Regular': ModeratRegular,
  'Moderat-Regular-Italic': ModeratRegularItalic,
}

export {
  AbbVieEAPImage,
  AmexBenefitsImage,
  AccessHopeImage,
  AmWellImage,
  AmgenAnthemImage,
  CalmLogo,
  MeQuilibriumLogo,
  ComPsychImage,
  VirginPulseLogo,
  HeadspaceLogo,
  DellWellnessHubImage,
  FidelityLogo,
  HappifyLogo,
  WhilLogo,
  KaiserImage,
  UHCImage,
  ThriveImage,
  RallyImage,
  LSCoImage,
  ReThinkLogo,
  SpiritualHealthImage,
  CaregiverWellnessImage,
  CredibleMindImage,
  CampBWellLogo,
  AycoLogo,
  SleepioImage,
  DaylightImage,
  ConsumerMedicalImage,
  PAHPImage,
  OptumImage,
  FIQImage,
  FitStudioImage,
  PowerOfWellnessImage,
  WeightWatchersImage,
  CareOptionCoaching,
  CareOptionCareerWellbeing,
  CareOptionCouplesAndFamilyTherapy,
  CareOptionEmployerBenefits,
  CareOptionMedicationManagement,
  CareOptionOutPatientSupport,
  CareOptionParentingSupport,
  FreshTriLogo,
  MyAgileLifeLogo,
  SupportivImage,
  WalmartSparkLogo,
  WellBeingAtWalmartLogo,
  ToolkitPromotionFamilyImage,
  WellnessToolkitMobileParentImage,
  WellnessToolkitWorkImage,
  WellnessToolkitPurposeImage,
  WellnessToolkitRelationsImage,
  WellnessToolkitHeaderImage,
  WellnessToolkitHeaderLyraSelectImage,
  WellnessToolkitMobileHeaderLyraSelectImage,
  WellnessToolkitMobileHeaderImage,
  WellnessToolkitFooterImage,
  CarrumHealthImage,
  CumminsAnthemImage,
  MayoClinicImage,
  TeledocHealthImage,
  RibbonHeart,
  DawnBackground,
  DawnBackgroundMobile,
  DawnBackgroundMobileWeb,
  DawnBackgroundWiderAspectRatio,
  MedsConsultationPng,
  TreatmentDetailTemplateHeaderDesktopImage,
  TreatmentDetailTemplateHeaderMobileImage,
  AICoachIcon,
  ConfirmedImage,
  ReferralsImage,
  ScheduleImage,
}

export const SelfCareWellnessTopicBackgroundImage = {
  uri: `${CDN_ASSETS_LINK_BASE}/SelfCareWellnessTopicBackground@2x.png`,
}

export const SSOReconciliationVerifyEmailBackgroundImage = {
  uri: `${CDN_ASSETS_LINK_BASE}/SSOReconciliationVerifyEmailBackground.png`,
}
export const CareTeamIllustrationPng = { uri: `${CDN_ASSETS_LINK_BASE}/careTeamIllustration.png` }
export const GraduatedFromActivities = { uri: `${CDN_ASSETS_LINK_BASE}/graduatedFromActivities.png` }
export const LyraSelectSkyBackground = { uri: `${CDN_ASSETS_LINK_BASE}/LyraSelectSkyBackground.png` }
export const NoNewActivities = { uri: `${CDN_ASSETS_LINK_BASE}/noNewActivities.png` }
export const ProviderCalendarCheckmark = { uri: `${CDN_ASSETS_LINK_BASE}/providerCalendarCheckmark.png` }
export const RegistrationCheckEmailAnimation = { uri: `${CDN_ASSETS_LINK_BASE}/registration_check_email_animation.gif` }
export const RegistrationVariantBackground = { uri: `${CDN_ASSETS_LINK_BASE}/registrationVariantBackground.png` }

// Multi-resolution assets from your list
export const HomebaseIllustration = { uri: `${CDN_ASSETS_LINK_BASE}/homebase_illustration@2x.png` }

export const S4CLoadingAnimationMobile = { uri: `${CDN_ASSETS_LINK_BASE}/S4CLoadingAnimationMobile.gif` }
export const S4CLoadingAnimationDesktop = { uri: `${CDN_ASSETS_LINK_BASE}/S4CLoadingAnimationDesktop.gif` }

export const CardMeds = { uri: `${CDN_ASSETS_LINK_BASE}/card_meds@3x.png` }

export const ConstellationCloudsBackgroundMobile = {
  uri: `${CDN_ASSETS_LINK_BASE}/constellationCloudsBackgroundMobile@2x.png`,
}

export const selectHomebaseHeaderCurvedBGDarkMode = {
  uri: `${CDN_ASSETS_LINK_BASE}/selectHomebaseHeaderCurvedBGDarkMode@2x.png`,
}

export const selectHomebaseHeaderCurvedBGDarkModeDesktop = {
  uri: `${CDN_ASSETS_LINK_BASE}/selectHomebaseHeaderCurvedBGDarkModeDesktop.png`,
}

export const CareNavigatorGeneralEntryPointImage = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorGeneralEntryPointImage.png`,
}

export const CareNavigatorGeneralEntryPointImageDesktop = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorGeneralEntryPointImageDesktop.png`,
}

export const CareNavigatorsSquare = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorsSquare.png`,
}

export const CareNavigatorsSquareDesktop = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorsSquareDesktop.png`,
}
